// export constants used throughout the program to avoid working with strings.
export const getProgramsColumnTypes = "getProgramsColumnTypes";
export const getProgramsMeasures = "getProgramsMeasures";
export const getProgramsChannels = "getProgramsChannels";
export const executeExportProgramsQuery = "executeExportProgramsQuery";
export const executeProgramsQuery = "executeProgramsQuery";
export const executeProgramsQueryMoreExclude =
  "executeProgramsQueryMoreExclude";
export const getProgramsTimeshift = "getProgramsTimeshift";
export const changeSortPrograms = "changeSortPrograms";
export const executeProgramsRoFQuery = "executeProgramsRoFQuery";
export const getProgramsGenres = "getProgramsGenres";
export const executeScheduleQuery = "executeScheduleProgramsQuery";
